import React from 'react';

const ConfirmIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries-large">
      <div className="vbz-icon-beneficiaries-large-confirm-team" />
    </div>
  );
};

export default ConfirmIcon;
